export default __webpack_public_path__ + "static/media/check-circle-white.1a39b1d4.svg";